/* Core & libraries */
import React, {useCallback} from "react";
import {useTheme} from "react-jss";
import {FormattedMessage} from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { REDEMPTION_HISTORY_GRID_TYPE } from "../RedemptionHistoryFilters/index.js";

/* Components */
import {ReactComponent as HourGlassSvg} from "resources/images/hourglass-cercle.svg";
import {ReactComponent as CompletedCheckIcon} from "resources/images/featured-completed-check-icon.svg"; 
import {ReactComponent as SearchSvg} from 'resources/images/search-cercle.svg';

/* Styles */
import styles from "./styles.js"
import UCButton from "components/buttons";
import classNames from "classnames";


const RedemptionHistoryGridHeader = (props = {}) => {
  const {gridOptions, setGridOptions} = props;
  const theme = useTheme();
  const classes = styles({theme});

  const setGridSearchTerm = useCallback(() => {
    setGridOptions(gridOptions => ({...gridOptions, page: 1, searchterm: undefined}))
  }, []);


  return (
    <div className={classes.redemptionHistoryWrapper}>
      <div className={classes.logo}>
        {gridOptions?.searchterm ? <SearchSvg/> : (gridOptions?.type === REDEMPTION_HISTORY_GRID_TYPE.COMPLETED ? <CompletedCheckIcon /> : <HourGlassSvg/>)}
      </div>

      <h1>
        {gridOptions?.searchterm ? <FormattedMessage id="redemptionHistory.grid.header.search.title"/> :
          <FormattedMessage id="redemptionHistory.grid.header.title"/>}
      </h1>
      <p>
        {gridOptions?.searchterm ? <FormattedMessage id="redemptionHistory.grid.header.search.description"/> :
          <FormattedMessage id="redemptionHistory.grid.header.description"/>}
      </p>

      {gridOptions?.searchterm ?
        <UCButton
          type="default"
          variant="outline"
          onClick={setGridSearchTerm}
          className={classNames(classes.noDataButton)}
          iconClassName={classes.clearBtnIcon}
        >
          <FormattedMessage id="redemptionHistory.grid.header.clearButton"/>
        </UCButton>
        : null}
    </div>
  )
}

export default RedemptionHistoryGridHeader;
